import { useForm, Controller, type SubmitHandler } from "react-hook-form"
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'

import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import { useCreateByEokoContact } from "@/hooks/api/use-municipality"
import EokoMunicipalitiesLoader from "@/wrappers/eoko-municipalities-loader"
import type { MunicipalityFormInput } from "@/types"
import RHFTextfield from "@/components/form-fields/rhf-textfield"

const MunicipalityForm = ({
    closeCallback,
} : {
    closeCallback?: () => void,
}) => {

    const initialValues = {
        id: '',
        name: '',
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
        error,
        setError,
    } = useFormStates(() => reset(initialValues))

    const mutation = useCreateByEokoContact(
        {
            setRequestInProgress,
            onSuccessCallback: closeCallback,
            onErrorCallback(errorMessage) {
                setError(errorMessage)
            }
        }
    )

    const onSubmit: SubmitHandler<MunicipalityFormInput> = data => {
        setRequestInProgress(true)
        mutation.mutate(data)
    }

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            heading={'Nahrát obec z EOKA'}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={false}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            error={error}
            setError={setError}
            buttonText="Uložit"
        >
            <EokoMunicipalitiesLoader>
                {eokoMunicipalities => (
                    <FormControl fullWidth>
                        <InputLabel id="collection-company-select-label">Vyberte z EOKO kontaktů</InputLabel>
                        <Controller
                            name="id"
                            control={control}
                            render={({ field }) => (
                                <Select {...field} label="Vyberte z EOKO kontaktů">
                                    <MenuItem key="none" value="">-</MenuItem>
                                    {eokoMunicipalities.map(municipality => (
                                        <MenuItem key={municipality.id} value={municipality.id}>{municipality.name} ({municipality.customer?.name})</MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                )}
            </EokoMunicipalitiesLoader>
            <RHFTextfield
                name="name"
                control={control}
                label="Název v Jaktridim.cz"
            />
        </Form>
    )
}

export default MunicipalityForm
